<template>
<div>


<div    @click="select($event, data)"   v-bind ='[{id:data.id}]' :class="{'page_list_row-selected': data.add_info.selected}"  class="page_list_row clearfloat selectable"    >

<div class="gpage_photo"><img     v-bind ='{src:data.photo_100}'    />   </div>
<div class="gpage_info selectable">
<div class="glabeled_name selectable"  > <a v-bind ='{href:data.url}' target="_blank"  style="text-decoration:none; color:#42648b;">  <span >{{data.name.substring( 28,-1).toLowerCase()}}</span> <v-tooltip close-delay="1" bottom  v-if="data.name.length >28"  max-width="320">
<span slot="activator">...</span><span>{{data.name}}</span> </v-tooltip> </a>  </div>
<div  class="glabeled selectable" >  # {{likes.selectedCat.name}}     </div>
<div v-if="data.likes_count > 0"   @click="history(data,index)">
<v-tooltip top max-width="250">
<span>Количество зарегистрированных лайков за все время, кликните что бы просмотреть страницы, которые оставляли лайки</span>
<div slot="activator">
<v-icon color="red" small>mdi-heart-circle-outline</v-icon> <span style="margin-left:3px; color:#42648b">{{data.likes_count}}</span>
</div>
</v-tooltip>
</div>
</div>



<div     class="gfunctions selectable"  >
<div    style="float:right">

<v-tooltip top >
<span>Получить новые лайки</span>
<v-btn class="ma-0 pa-0" small icon slot="activator"><v-icon  @click="checker(data,index)">mdi-update</v-icon></v-btn>
</v-tooltip>

<v-tooltip top>
<span>Настройки парсера лайков</span>
<v-btn class="ma-0 pa-0" small icon slot="activator"><v-icon  @click="history(data,index)">mdi-tune</v-icon></v-btn>
</v-tooltip>


</div>
</div>

  </div>


</div>
</template>




<script>
import axios from 'axios'
export default {

props: ['data','index', 'likes', 'modals','groups'],
 data: function(){
  return {
   ui:{
     options: false
   },
   isSelected: false
  }
},
methods: {

checker(data,index){

this.likes.checker.foundData.selector = false
this.likes.checker.foundData.foundIds = []
this.likes.checker.foundData.displayIds = []
this.likes.checker.foundData.selectedIds = []
this.likes.checker.foundData.offset = 0



this.likes.checkList = []
this.likes.checkList.push(data.id)
this.likes.modals.checkGroup = true
},



 history: function(data,index){

   this.groups.history.historyId = data.id_of_group
   this.modals.history = true
   this.getHistoryList(data.id_of_group)

},
getHistoryList: function(grId){

  this.groups.history.foundData.foundIds = []
  this.groups.history.foundData.displayIds = []
  this.groups.history.foundData.selector = false
  this.groups.history.foundData.selectedIds = []
  this.groups.history.foundData.offset = []

  this.groups.history.foundDataOut.foundIds = []
  this.groups.history.foundDataOut.displayIds = []
  this.groups.history.foundDataOut.selector = false
  this.groups.history.foundDataOut.selectedIds = []
  this.groups.history.foundDataOut.offset = []


  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/groups_history.php', {

       method: 'POST',
       data: {
         grId: grId,

       }
     })
     .then( response => {

       this.groups.history.foundData.foundIds = response.data.in
       this.groups.history.foundDataOut.foundIds = response.data.out

     })
},

select(event,data){
let classes = event.target.className.split(' ')
if(classes.indexOf('selectable') !== -1){
data.add_info.selected = !data.add_info.selected
if(data.add_info.selected){
this.likes.selectedSrc.push(data)
} else   this.likes.selectedSrc.splice(this.likes.selectedSrc.indexOf(data),1)
}
},


}
}
</script>

<style>
.clearfloat:after {
 content: "";
 display: table;
 clear: both;
}

.page_list_row_selected{
background-color : #EDF0F5;
border-radius : 7px
}



.page_list_row {

  margin: 15px;


  }

.page_list_row:hover {
  margin: 15px;
  border-radius:5px;
  cursor: pointer;
  }

.page_list_row .gpage_info  {

 padding-top: 10px;
 float: left;
   margin-bottom: 5px;
 margin-right: 25px;
   overflow: hidden;

   width: 250px;
 min-height: 80px;
}

.page_list_row .gpage_info .glabeled_name{


    margin-bottom: 5px;
  color: #42648b;
    font-weight: 700;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;

}
.page_list_row .gpage_info .glabeled_name:first-letter{
   text-transform: capitalize;
}

.page_list_row .glabeled {

   color: #656565;
}

.page_list_row .gfunctions {
   padding: 7px 0 0;
  position: relative;
   overflow: hidden;
   width: 150px;
   height: 80px;
 }

.page_list_row .gpage_photo {


   float: left;
   margin: 3px;
   margin-right: 9px;
   position: relative;
   width: 80px;
   height: 80px;
   overflow: hidden;
}

.page_list_row .gpage_photo img {

   width: 80px;
   height: 80px;
   border-radius: 50%;
   -moz-force-broken-image-icon: 0;
   background-color: #fafbfc;
}



</style>
